import React from 'react'
import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'

export default function ForbiddenPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center py-20 px-4 sm:px-6 bg-[#f4f4f5]">
      <SeoHead
        title="Adgang nægtet (403) - Emmerske Efterskole"
        description="Du har ikke adgang til denne ressource på Emmerske Efterskole."
      />

      <div className="max-w-xl mx-auto text-center bg-white p-8 sm:p-12 rounded-3xl border border-stone-200/80 shadow-lg space-y-6">
        <div className="w-20 h-20 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center mx-auto text-3xl font-extrabold">
          403
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl sm:text-3xl font-extrabold text-[#122020]">
            Adgang nægtet (403)
          </h1>
          <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
            Du har ikke tilladelse til at se dette indhold eller denne mappe.
          </p>
        </div>

        <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/" className="btn-primary w-full sm:w-auto">
            <i className="fa-solid fa-house" aria-hidden="true" />
            <span>Tilbage til forsiden</span>
          </Link>
          <Link to="/kontakt" className="btn-secondary w-full sm:w-auto">
            <i className="fa-solid fa-envelope" aria-hidden="true" />
            <span>Kontakt kontoret</span>
          </Link>
        </div>
      </div>
    </div>
  )
}
